<template>
  <div>
    <nav-bar/>
    <div class="container">
      <div class="row page-padding">
        <div class="col-sm-3 col-12">
          <div class="mb-2">
            از تاریخ:
          </div>
          <div>
            <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-left="100"
                min-width="auto"
                offset-y
                transition="scale-transition">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="inputDate1"
                    v-bind="attrs"
                    v-on="on"
                    append-icon="fa-calender-alt"
                    class="input-border"
                    dense
                    flat
                    hide-details
                    readonly
                    solo></v-text-field>
              </template>
              <v-date-picker
                  v-model="date1"
                  color="primary"
                  locale="fa-ir"
                  width="256"
                  @input="inputDatePicker1"></v-date-picker>
            </v-menu>
          </div>
        </div>
        <div class="col-sm-3 col-12">
          <div class="mb-2">تا تاریخ:
          </div>
          <div>
            <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                min-width="auto"
                offset-y
                transition="scale-transition">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="inputDate2"
                    v-bind="attrs"
                    v-on="on"
                    class="input-border"
                    color="secondary"
                    dense
                    flat
                    hide-details
                    readonly
                    solo>
                </v-text-field>
              </template>
              <v-date-picker
                  v-model="date2"
                  color="secondary"
                  locale="fa-ir"
                  width="256"
                  @input="inputDatePicker2"></v-date-picker>
            </v-menu>
          </div>
        </div>
        <div class="col-sm-3 col-12">
          <div class="mb-2">کد تیکت:</div>
          <v-text-field
              v-model="ticketNumber"
              flat
              dense
              class="input-border"
              solo
              type="number">
          </v-text-field>
        </div>
        <div class="col-sm-3 col-12">
          <div class="mb-2">وضعیت تیکت:</div>
          <v-autocomplete
              solo
              flat
              dense
              hide-details
              color="primary"
              class="input-border"
              :items="$TypeTicketStatus"
              v-model="TypeTicketStatus"
              item-text="name"
              item-value="id"
              placeholder="وضعیت تیکت را انتخاب کنید">
          </v-autocomplete>
        </div>
        <div class="col-sm-3 col-12 align-self-center">
          <v-btn color="primary" class="rounded-lg" elevation="0" dark
                 @click="searchTickets">
            <span class="font16px">جستجو</span>
          </v-btn>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row" v-if="list.length === 0">
        <div class="col-10 mx-auto">
          <v-alert
              class="font-19 text-center white--text" color="info">
            تیکتی یافت نشد.
          </v-alert>
        </div>
      </div>
      <div v-if="list.length > 0" class="col-12">
        <v-text-field
            v-model="search"
            append-icon="fa-search"
            class="input-border mb-1"
            label="جستجو"
            single-line
            solo></v-text-field>
        <v-data-table
            id="dataTable"
            :headers="headers"
            :items="list"
            :light="true"
            :mobile-breakpoint="767"
            :page="pageIndex"
            :items-per-page="pageSize"
            :server-items-length="total"
            :search="search"
            class="data-table"
            fixed-header
            item-key="TicketId"
        >
          <template v-slot:[`item.Counter`]="{ index }">
            <div>{{ index + 1 }}</div>
          </template>
          <template v-slot:[`item.date`]="{ item }">
            <div>{{ $convertDate(item.UpdatedDate) }}</div>
          </template>
          <template v-slot:[`item.TypeTicketStatus`]="{ item }">
            <div>{{ $TypeTicketStatus[item.TypeTicketStatus - 1].name }}</div>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-btn
                color="primary"
                elevation="0"
                :to="{path: 'ticketsDetailClient', query:{id:item.TicketId}}"
            >
              جزییات
            </v-btn>
          </template>
          <template v-slot:expanded-item="{ item }">
            <td>
              <div v-if="item.Description === ''">
                بدون توضیح
              </div>
              <div v-else>
                <div v-html="item.Description"></div>
              </div>
            </td>
          </template>
        </v-data-table>
      </div>
    </div>
    <v-overlay
        v-model="showLoaderDialog"
        persistent
        width="500">
      <v-progress-circular
          color="white"
          indeterminate
          size="50"
      ></v-progress-circular>
    </v-overlay>

  </div>
</template>

<script>
import NavBar from "@/Ticketing/components/navBar";
import moment from "moment-jalaali";

export default {
  name: "listTickets",
  components: { NavBar},
  metaInfo() {
    return {
      title: 'تیکتینگ-تیکت های من '
    }
  },
  data: () => ({
    ticketNumber: null,
    menu1: false,
    isLoggedIn: false,
    pageIndex: 1,
    pageSize: 30,
    total:0,
    inputDate1: "",
    date1: "",
    search: null,
    personnel: null,
    users: null,
    TypeTicketStatus: null,
    inputDate2: "",
    menu2: false,
    date2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    expanded: [],
    UserItems: [],
    personnelItems: [],
    singleExpand: true,
    showLoaderDialog: false,
    headers: [
      {text: 'ردیف', value: 'Counter', sortable: false,},
      {text: 'شناسه تیکت', value: 'TicketNumber', sortable: false,},
      {text: 'عنوان', value: 'Subject', sortable: false,},
      {text: 'واپسین به روز رسانی', value: 'date', sortable: false,},
      {text: 'وضعیت', value: 'TypeTicketStatus', sortable: false,},
      {text: '', value: 'action', sortable: false,},
    ],
    list: [],
    src: 'logo2.png'
  }),

  mounted() {
    let current = new Date();
    current.setDate(current.getDate() - 60);
    this.date1 = current.toISOString().substr(0, 10);
    this.inputDate1 = this.$convertDate(this.date1);
    this.inputDate2 = this.$convertDate(this.date2);
    this.searchTickets()


  },
  methods: {
    inputDatePicker1() {
      this.menu1 = false;
      this.inputDate1 = moment(this.date1).format("jYYYY/jMM/jDD");
    },
    inputDatePicker2() {
      this.menu2 = false;
      this.inputDate2 = moment(this.date2).format("jYYYY/jMM/jDD");
    },
    searchTickets() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      var url = "/Client/UsersTicketsList?startDate="
          + this.inputDate1 + "&endDate=" + this.inputDate2

      if (this.ticketNumber !== null) {
        url += "&ticketNumber=" + this.ticketNumber;
      }
      if (this.TypeTicketStatus !== null) {
        url += "&TypeTicketStatus=" + this.TypeTicketStatus;
      }
      url += "&pageIndex=" + this.pageIndex + "&pageSize=" +  this.pageSize;

      fetch(this.$baseUrl + url, requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            /*       for (let i = 0; i < json.list.length; i++) {
                     // json[i].fullName = json[i].Name + " " + json[i].Family;
                     var user = this.UserItems.filter(x => x.Id === json.list[i].AppUserId)[0]
                     json.list[i].user = user.Name + " " + user.Family
                   }*/
            this.list = json.list
            this.total = json.totalCount;
            this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));
    },
    silentLogin() {
      let userData = this.$getUserData()
      if (userData.mobile !== '' && userData.activeCode !== '' && userData.mobile !== undefined && userData.activeCode !== null) {
        let resStatus = null
        let myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        let urlencoded = new URLSearchParams();
        urlencoded.append("PhoneNumber", userData.mobile);
        urlencoded.append("VerifyCode", userData.activeCode);

        let requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: urlencoded,
          redirect: 'follow'
        };

        fetch(this.$baseUrl + "/Client/Login", requestOptions)
            .then(response => {
              resStatus = response.status
              return response.text()
            })
            .then(result => {
              this.showLoaderDialog = false
              if (resStatus === 200) {
                let json = JSON.parse(result)
                let token = 'Bearer ' + json.JwtToken
                this.$setUserData(userData.mobile, userData.activeCode, token, json.Role);
                this.isLoggedIn = true;
              } else {
                this.isLoggedIn = false
              }
            })
            .catch(error => console.log('error', error));
      } else {
        this.isLoggedIn = false
      }


    },
  }
}
</script>

<style scoped>

</style>